var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col md:flex-row md:h-screen bg-background"},[_c('Sidebar'),_c('main',{staticClass:"flex-1 overflow-y-auto"},[_c('div',{staticClass:"container mx-auto p-4 sm:p-6 max-w-7xl"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }